function invoiceSetDraft(InvoiceSeries, UserInfo, filtersUtils) {
    return {
        restrict: 'AE',
        scope: {},
        templateUrl: require('../../templates/draft-button.html'),
        controller: function ($scope, $http, $rootScope, Alert, $filter) {
            /***********************************************************************************************************
            * Controller Attributes
            ***********************************************************************************************************/
            var api = API_URL + '/api/1.0/invoices/';
            var $translate = $filter('translate');

            /***********************************************************************************************************
            * Scope Attributes
            ***********************************************************************************************************/
            $scope.flagDraft = false;
            $scope.listToUpdate = [];

            $scope.hasPerm = UserInfo.hasPerm('invoices.set_invoice_draft');

            /***********************************************************************************************************
            * Scope Watchers
            ***********************************************************************************************************/
            $scope.$on("selectedItemsChange", function (e, selectedItemsChange) {
                    $scope.listToUpdate = selectedItemsChange;
            });

            $scope.$on("selectedCounterChange", function (e, selectedCounterChange) {
                $scope.counter = selectedCounterChange;
            });

            /***********************************************************************************************************
            * Controller Methods
            ***********************************************************************************************************/
            function performRequest(ids) {
                //Alert.createAlert('info', $translate('INVOICES.SENDING_DRAFT'), true);
                var json = {ids: ids, status: "DRF"};

                var config = {
                    method: "PUT",
                    url: api,
                    data: json,
                    headers: {"Content-Type": "application/json;charset=utf-8"}
                };
                $http(config)
                    .then(function (data, status, headers, config) {
                        Alert.createAlert('success', $translate('INVOICES.SENT_DRAFT_OK') + data.data.updated_number, true);
                        $rootScope.$broadcast('refreshList');
                    }, function (data, status, headers, config) {
                        Alert.createAlert('danger', $translate('INVOICES.SENT_DRAFT_KO'), true);
                    })
                    /*
                    .finally(function () {
                        $scope.flagDraft = false;
                        $scope.listToUpdate = [];
                        $scope.$parent.loading = false;
                    });
                    */
            }

            /***********************************************************************************************************
            * Scope Methods
            ***********************************************************************************************************/
            $scope.confirmUpdate = function () {
                $scope.flagDraft = true;
            };

            $scope.updateNo = function () {
                $scope.flagDraft = false;
            };

            $scope.updateYes = function () {
                var ids = filtersUtils.getItemsToDownloadToInt($scope.listToUpdate);
                performRequest(ids);
            };
        }
    }
}

export { invoiceSetDraft }
